import React from 'react'
import { HeaderWrapper } from './HeaderStyled'
import Close from './Close'
import { HeaderProps } from './interfaces'

export default function Header({
  name,
  handleAbove,
  strokeColor,
  background,
  borderColor,
  textColor,
  styles,
  audio,
}: HeaderProps) {
  return (
    <HeaderWrapper
      style={styles}
      strokeColor={strokeColor}
      background={background}
      borderColor={borderColor}
      textColor={textColor}
    >
      <h1>{name}</h1>
      <Close handleAbove={handleAbove} audio={audio} />
    </HeaderWrapper>
  )
}
